import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'

import { accountsService } from 'src/services/accounts.service'

export const useRequestAccountPrivateKey = () => {
  const { accountId } = useParams()

  return useMutation(async () => (accountId ? accountsService.requestPrivateKey(accountId) : null))
}
